module.exports = __webpack_public_path__ + "static/media/1.3c7c2c1d.jpg";